import moment from 'moment'
import 'moment/min/locales.min'

import { getLanguage } from './Locale'

export const getIncludedDays = (
    date,
    startDay,
    dayCount,
    language,
    displayMode,
    excludedDays = []
) => {
    const _date = moment(date)
    let includedDays = [_date]
    if (dayCount > 1 && displayMode !== 'print') {
        // const firstDayOfWeek = date.locale(this.props.language).startOf('week');
        const days = [
            'sunday',
            'monday',
            'tuesday',
            'wednesday',
            'thurday',
            'friday',
            'saturday',
        ]
        moment.updateLocale(getLanguage(language), {
            week: {
                dow: displayMode !== 'week' && startDay === 'today'
                    ? moment().day()
                    : days.filter(day => day !== 'today').indexOf(startDay) 
            },
        })
        const firstDayOfWeek = _date
            .locale(getLanguage(language))
            .startOf('week')
        includedDays = [firstDayOfWeek]
        for (let i = 0; i < dayCount - 1; i++) {
            if (!includedDays[i]) {
                continue
            }
            const dayToAdd = includedDays[i].clone().add(1, 'd')
            includedDays.push(dayToAdd)
        }
    }
    return includedDays.filter(_ => excludedDays.indexOf(_.day()) === -1)
}
